import PropTypes from "prop-types"
import React, { useEffect } from "react"

import { withRouter } from "react-router-dom"

// Layout Related Components
import Footer from "./Footer"
import Header from "./Header"
import Sidebar from "./Sidebar"

//redux
import IdleTimeOutHandler from "components/SessionTimeOut/IdleTimeOutHandler"

const Layout = props => {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <React.Fragment>
      <div id="layout-wrapper">
        <IdleTimeOutHandler
          onActive={() => {}}
          onIdle={() => {}}
          onLogout={() => {
            window.location.replace("/logout")
          }}
        />
        <Header />
        <Sidebar />
        <div className="main-content">{props.children}</div>
        <Footer />
      </div>
    </React.Fragment>
  )
}

Layout.propTypes = {
  children: PropTypes.object,
}

export default withRouter(Layout)
